export default __webpack_public_path__ + "static/media/caseta.c587921e.svg";